import React, { FC } from 'react';
import styles from './UserManagementEventLoggingFilterOrganism.module.css';
import cn from 'classnames';
import { Button, InputField } from '../../atoms';
import { CustomDropdown } from '../../molecules';
import { EventLogMessageResponseEventLogActionEnum } from '../../../store/contextAPI/eventLogging/event-log-message-response-event-log-action-enum';
import { EventLogMessageResponseEventLogContextTypeEnum } from '../../../store/contextAPI/eventLogging/event-log-message-response-event-log-context-type-enum';
import { toast } from 'react-toastify';

interface DropDownItem {
  eventKey: string;
  label: string;
}

interface UserManagementEventLoggingFilterOrganismProps {
  actionFilter: string;
  contextTypeFilter: string;
  setActionFilter: React.Dispatch<React.SetStateAction<string>>;
  setContextTypeFilter: React.Dispatch<React.SetStateAction<string>>;
  handleReset: () => void;
  handleSearch: () => void;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  searchTerm: string;
  fromDate: string;
  setFromDate: React.Dispatch<React.SetStateAction<string>>;
  toDate: string;
  setToDate: React.Dispatch<React.SetStateAction<string>>;
}

const UserManagementEventLoggingFilterOrganism: FC<
  UserManagementEventLoggingFilterOrganismProps
> = ({
  actionFilter,
  setActionFilter,
  handleReset,
  contextTypeFilter,
  setContextTypeFilter,
  handleSearch,
  searchTerm,
  setSearchTerm,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
}) => {
  const contextDropDownItems: DropDownItem[] = Object.values(
    EventLogMessageResponseEventLogContextTypeEnum
  ).map((value) => {
    return {
      eventKey: value,
      label: value,
    };
  });

  const validateDateRange = () => {
    if (fromDate && toDate && new Date(toDate) < new Date(fromDate)) {
      toast('Oops! Invalid date range.');
      setFromDate(toDate);

      return false;
    }
    return true;
  };

  const actionDropDownItems: DropDownItem[] = Object.values(
    EventLogMessageResponseEventLogActionEnum
  ).map((value) => {
    return {
      eventKey: value,
      label: value,
    };
  });

  const handleActionSelect = (selectedItem: DropDownItem) => {
    setActionFilter(selectedItem.eventKey);
  };

  const handleContextTypeSelect = (selectedItem: DropDownItem) => {
    setContextTypeFilter(selectedItem.eventKey);
  };

  const onSearch = () => {
    if (validateDateRange()) {
      handleSearch();
    }
  };

  return (
    <div className={cn(styles.eventLoggingWrapper)}>
      <div className={cn(styles.row)}>
        <div className={cn(styles.inputFieldWrapper)}>
          <InputField
            type="text"
            placeholder="Search..."
            id="search"
            value={searchTerm}
            onChange={(value) => setSearchTerm(value)}
          />
        </div>
        <div className={cn(styles.inputFieldWrapper)}>
          <InputField
            type="date"
            placeholder="From..."
            id="from"
            value={fromDate}
            onChange={(value) => setFromDate(value)}
          />
        </div>
        <div className={cn(styles.inputFieldWrapper)}>
          <InputField
            type="date"
            placeholder="To..."
            id="to"
            value={toDate}
            onChange={(value) => setToDate(value)}
          />
        </div>
        <Button className={cn(styles.button)} variant="dark" onClick={onSearch}>
          Search
        </Button>
      </div>

      <div className={cn(styles.row)}>
        <div className={cn(styles.dropDownWrapper)}>
          <CustomDropdown
            initialTitle={contextTypeFilter || 'Context type...'}
            items={contextDropDownItems}
            onSelectOption={handleContextTypeSelect}
          />
        </div>
        <div className={cn(styles.dropDownWrapper)}>
          <CustomDropdown
            items={actionDropDownItems}
            initialTitle={actionFilter || 'Action...'}
            onSelectOption={handleActionSelect}
          />
        </div>
        <Button
          onClick={() => {
            setActionFilter('');
            setContextTypeFilter('');
            setFromDate('');
            setToDate('');
            handleReset();
          }}
          className={cn(styles.button)}
          variant="light"
        >
          Reset
        </Button>
      </div>
    </div>
  );
};

export default UserManagementEventLoggingFilterOrganism;
